export class WishListModel {
  itemId: string;
  email: string;

  constructor(){
    this.itemId = "";
    this.email = "";
  }
}
